import { render, staticRenderFns } from "./FixedFooter.vue?vue&type=template&id=1c8d4b78&"
import script from "./FixedFooter.vue?vue&type=script&lang=js&"
export * from "./FixedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports